import z from 'zod';

import { AutoCompleteDtoSchema } from './AutoCompleteDto';
import { AutoCompleteDto } from './AutoCompleteDto';

export type AccessoryStartingWithResponseModel = {
	accessories: AutoCompleteDto[];
};

export const AccessoryStartingWithResponseModelSchema: z.ZodType<AccessoryStartingWithResponseModel> =
	z.object({
		accessories: z.lazy(() => AutoCompleteDtoSchema).array(),
	});
